import {Record, Map} from 'immutable';
import {
  type NetworkStatus,
  type ConfirmationStatus,
  COMMERCE_SETTINGS_ID,
  NETWORK_STATUSES,
  CONFIRMATION_STATUSES,
  DEFAULT_PAYMENT_GATEWAY_SUPPORT,
  INTEGRATIONS,
} from './constants';

export const inventorySyncPlatformMap: Map<string, Map<string, any>> = Map({
  [INTEGRATIONS.FACEBOOK.code]: Map({
    keyPath: ['integrations', 'facebookFeedEnabled'],
    name: INTEGRATIONS.FACEBOOK.name,
    platform: INTEGRATIONS.FACEBOOK.code,
    logo: INTEGRATIONS.FACEBOOK.logo,
    logoLarge: INTEGRATIONS.FACEBOOK.logoLarge,
    feedUrl: null,
  }),
  [INTEGRATIONS.GOOGLE.code]: Map({
    keyPath: ['integrations', 'googleFeedEnabled'],
    name: INTEGRATIONS.GOOGLE.name,
    platform: INTEGRATIONS.GOOGLE.code,
    logo: INTEGRATIONS.GOOGLE.logo,
    logoLarge: INTEGRATIONS.GOOGLE.logoLarge,
    feedUrl: null,
  }),
});

const EMAIL_TYPE_RECIPIENTS = Map({
  owner: true,
  collaborators: true,
  extraEmails: [],
});

const EMAIL_RECIPIENTS = Map({
  recipients: Map({
    orderReceived: EMAIL_TYPE_RECIPIENTS,
    orderConfirmed: EMAIL_TYPE_RECIPIENTS,
    orderShipped: EMAIL_TYPE_RECIPIENTS,
    orderRefunded: EMAIL_TYPE_RECIPIENTS,
    orderDownloads: EMAIL_TYPE_RECIPIENTS,
  }),
});

export const CommerceSettingsStateRecord = Record({
  _id: COMMERCE_SETTINGS_ID,
  defaultCurrency: null,
  defaultCurrencyLocale: null,
  defaultCurrencyFormat: null,
  // this stores the inital defaultCurrencyFormat when the CommerceAdvancedPriceFormatSettingsModal is opened
  initialAdvancedCurrencyFormat: null,
  defaultUnits: null,
  defaultTaxCategory: null,
  storeName: '',
  supportEmail: '',
  priceIncludesTax: false,
  businessAddress: null,
  requestStatus: NETWORK_STATUSES.INIT,
  confirmationStatus: CONFIRMATION_STATUSES.INIT,
  shippingZones: null,
  countryTaxConfigs: [],
  currentAutoTaxCountry: null,
  // not sure what error state looks like from backend
  errors: null,
  savedDefaultCurrency: null,
  savedDefaultCurrencyLocale: null,
  savedDefaultCurrencyFormat: null,
  savedDefaultUnits: null,
  savedStoreName: '',
  savedSupportEmail: '',
  savedPriceIncludesTax: false,
  savedBusinessAddress: null,
  savedDefaultTaxCategory: null,
  nexusAddressPending: false,
  nexusAddresses: [],
  currentNexusAddress: null,
  currentShippingZone: null,
  isCountryModalOpen: false,
  currentShippingMethod: null,
  checkoutEnabled: false,
  savedCheckoutEnabled: false,
  quickCheckoutEnabled: false,
  savedQuickCheckoutEnabled: false,

  // integrations
  integrations: Map({
    facebookFeedEnabled: false,
    googleFeedEnabled: false,
  }),

  savedIntegrations: Map({
    facebookFeedEnabled: false,
    googleFeedEnabled: false,
  }),

  currentInventorySync: null,
  inventorySyncMap: inventorySyncPlatformMap,
  applePayDomIssues: null,
  showSetupGuide: true,
  savedShowSetupGuide: true,
  paymentGatewaySupport: DEFAULT_PAYMENT_GATEWAY_SUPPORT,

  currentEmailType: null,
  emails: EMAIL_RECIPIENTS,
  savedEmails: EMAIL_RECIPIENTS,

  hasNonCanceledSubscription: false,
}) as any;

export const defaultState = CommerceSettingsStateRecord();

export type CommerceSettingsStateRecordShape = typeof defaultState & {
  requestStatus: NetworkStatus;
  confirmationStatus: ConfirmationStatus;
};
